// extracted by mini-css-extract-plugin
export default {"formItem":"styles_formItem__JGjxg"};